module.exports = [{
      plugin: require('C:/Users/test/Desktop/gatsby-sophia-school/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/test/Desktop/gatsby-sophia-school/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    }]
